import { TemplateItem } from "types/";
import { LINE_ORIENTATIONS, Shape, TableDividerStyle } from "../../../types";
import { isGradient, mapToServerColor } from "../../itemsHelper";
import { DEFAULT_COLOR } from "../../../constants";

export const generateLine = (
  shape: Shape | TableDividerStyle
): TemplateItem["graphics"] => {
  const { orientation, size, background } = shape;
  const thickness =
    orientation && orientation === "vertical" ? size.width : size.height;

  return {
    type: "Line",
    //Lines do not support gradients
    color: isGradient(background)
      ? DEFAULT_COLOR
      : mapToServerColor(background),
    thickness: thickness,
    orientation: orientation ?? LINE_ORIENTATIONS.HORIZONTAL,
  };
};
